// extracted by mini-css-extract-plugin
export default {"secaocompleta":"SecaoItens_secaocompleta__x4JoX","semProdutos":"SecaoItens_semProdutos__xytU0","icon":"SecaoItens_icon__h9yfP"};